import {
  IMailingPriorityList,
  IServicesCategoryMailingList,
  IStrategyRegister,
} from 'components/StrategyRegister/interfaces';
import {
  IParsedSelectedServicesCategoryToBFF,
  IParsedStrategyToBFF,
  IStrategyResponse,
} from 'interfaces/Strategy';

export const parseStrategyResponse = (
  strategyResponse: IStrategyResponse,
): IStrategyRegister => {
  return {
    id: strategyResponse._id,
    _id: strategyResponse._id,
    name: strategyResponse.name,
    executionPeriodicityInDays: strategyResponse.executionPeriodicityInDays,
    status: strategyResponse.status,
    dateStatus: strategyResponse.dateStatus,
    selectedServiceCategories: strategyResponse.selectedServiceCategories?.reduce(
      (allServiceCategories, serviceCategory) => {
        const {
          servicesCategoriesId,
          prioritizedSelectedMailingRulesId: priorizeds,
        } = serviceCategory;

        if (
          !Object.prototype.hasOwnProperty.call(
            allServiceCategories,
            servicesCategoriesId._id,
          )
        ) {
          allServiceCategories[servicesCategoriesId._id] = priorizeds.reduce(
            (allMailings, mailing) => {
              if (
                !Object.prototype.hasOwnProperty.call(
                  allMailings,
                  mailing.mailingRuleId._id,
                )
              ) {
                allMailings[mailing.mailingRuleId._id] = {
                  activation: mailing.priority > 0,
                  priority: mailing.priority,
                };
              }
              return allMailings;
            },
            {} as IMailingPriorityList,
          );
        }

        return allServiceCategories;
      },
      {} as IServicesCategoryMailingList,
    ),
  };
};

export const parseServiceCategoriesToBFF = (
  serviceCategories: IServicesCategoryMailingList,
): IParsedSelectedServicesCategoryToBFF[] => {
  const selectedServiceCategoriesKeys = Object.keys(serviceCategories);

  return selectedServiceCategoriesKeys
    .map((k) => {
      const mailingsRulesKeys = Object.keys(serviceCategories[k]);
      const priorizedMailingsRulesKeys = mailingsRulesKeys.filter(
        (mailingKeys) => serviceCategories[k][mailingKeys].activation,
      );

      return {
        servicesCategoriesId: k,
        prioritizedSelectedMailingRulesId: priorizedMailingsRulesKeys.map(
          (priorizedMailingKey) => {
            const mailing = serviceCategories[k][priorizedMailingKey];
            return {
              priority: mailing.priority,
              mailingRuleId: priorizedMailingKey,
            };
          },
        ),
      };
    })
    .filter(
      (serviceCategory) =>
        serviceCategory.prioritizedSelectedMailingRulesId.length > 0,
    );
};

export const parseStrategyToSubmit = (
  strategy: IStrategyRegister,
): IParsedStrategyToBFF => {
  const {
    name,
    status,
    executionPeriodicityInDays,
    selectedServiceCategories,
  } = strategy;

  const parsedSelectedServiceCategories = selectedServiceCategories
    ? parseServiceCategoriesToBFF(selectedServiceCategories)
    : undefined;

  return {
    name,
    status,
    executionPeriodicityInDays,
    selectedServiceCategories: parsedSelectedServiceCategories,
  };
};
